<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import FollowerGoalWidget from '@/widgets/FollowerGoalWidget';

export default {
	name: 'FollowerGoalWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { if(this.widget) this.widget.applySettings({ ...s }); },
		},
	},
	mounted() {
		this.widget = new FollowerGoalWidget({ container: this.$refs.container });
		this.widget.init({ settings: { ...this.settings } });
	},
	beforeDestroy() {
		if(this.widget) {
			this.widget.destroy();
			this.widget = null;
			if(this.$refs.container) this.$refs.container.innerHTML = '';
		}
	},
};
</script>
